import React from 'react';
import RadioToggle from './../forms/RadioToggle';
import * as Scroll	from "react-scroll";

let Element    = Scroll.Element;
let Events     = Scroll.Events;
let scroll     = Scroll.scroller;
let scrollSpy  = Scroll.scrollSpy;

import ReactGA from 'react-ga';
ReactGA.initialize('UA-100475676-1');

class GetHelp extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      questions: {
        Question1: null,
        Question2: null,
        Question3: null,
        Question4: null,
        Question5: null,
        Question6: null,
        Question7: null,
        Question8: null
      },
      occupationalRating: null,
      usingToggleOne: false,
      questionsAnswered: false
    };

    this.questions = {
      Question1: this.updateSelection.bind(this, 'Question1'),
      Question2: this.updateSelection.bind(this, 'Question2'),
      Question3: this.updateSelection.bind(this, 'Question3'),
      Question4: this.updateSelection.bind(this, 'Question4'),
      Question5: this.updateSelection.bind(this, 'Question5'),
      Question6: this.updateSelection.bind(this, 'Question6'),
      Question7: this.updateSelection.bind(this, 'Question7'),
      Question8: this.updateSelection.bind(this, 'Question8')
    };
  }

  componentDidMount() {
    Events.scrollEvent.register('begin', function(to, element) {      
    });
  }

  updateSelection(propertyName, component) {
    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'User answered a question',
      label: propertyName,
      value: parseInt(component)
    });
    const questions = this.state.questions;
    questions[propertyName]= component;

    // determine show rating button

    let nodes = this.state.questions;

    if(this.state.questions.Question1 === '0' &&
    this.state.questions.Question2 === '0' &&
    this.state.questions.Question3 === '0' &&
    this.state.questions.Question4 === '1' &&
    this.state.questions.Question5 === '0') {
      if(this.state.questions.Question6 !== null &&
        this.state.questions.Question7 !== null &&
        this.state.questions.Question8 !== null) {
          this.setState({questionsAnswered: true}, () => this.props.callbackQuestions(this.state.questionsAnswered));
        } else {
          this.setState({questionsAnswered: false}, () => this.props.callbackQuestions(this.state.questionsAnswered));
        }
     } else if(
       this.state.questions.Question1 !== null &&
       this.state.questions.Question2 !== null &&
       this.state.questions.Question3 !== null &&
       this.state.questions.Question4 !== null &&
       this.state.questions.Question5 !== null){
       this.setState({questionsAnswered: true}, () => this.props.callbackQuestions(this.state.questionsAnswered));
     }

    this.setState({
      questions: questions
    });
  }


  handleSubmit(e, component) {

    scroll.scrollTo('scrollto-1', {
      smooth: true,
      containerId: 'App'
    });

    e.preventDefault();
    // high riskRating
    if(
      (this.state.questions.Question3 === '1')
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'High risk'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(this.state.questions.Question5 === '1') {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'High risk'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'Standard'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    }

    // professional
    if(
      this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' && this.state.questions.Question5 === '0' &&
      this.state.questions.Question1 === '0' && this.state.questions.Question4 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'Professional'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    }

    if(
      this.state.questions.Question1 === '0' && this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' &&
      this.state.questions.Question5 === '0' && this.state.questions.Question7 === '0' && this.state.questions.Question8 === '0' &&
      this.state.questions.Question4 === '1' && this.state.questions.Question6 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'White collar'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(
      this.state.questions.Question1 === '0' && this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' &&
      this.state.questions.Question5 === '0' && this.state.questions.Question6 === '0' && this.state.questions.Question8 === '0' &&
      this.state.questions.Question4 === '1' && this.state.questions.Question7 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'White collar'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(
      this.state.questions.Question1 === '0' && this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' &&
      this.state.questions.Question5 === '0' && this.state.questions.Question6 === '0' && this.state.questions.Question7 === '0' &&
      this.state.questions.Question4 === '1' && this.state.questions.Question8 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'White collar'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(
      this.state.questions.Question1 === '0' && this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' &&
      this.state.questions.Question5 === '0' && this.state.questions.Question6 === '0' && this.state.questions.Question4 === '1' &&
      this.state.questions.Question7 === '1' && this.state.questions.Question8 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'White collar'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(
      this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' && this.state.questions.Question5 === '0' &&
      this.state.questions.Question4 === '1' && this.state.questions.Question1 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'White collar'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(
      this.state.questions.Question1 === '0' && this.state.questions.Question2 === '0' && this.state.questions.Question3 === '0' &&
      this.state.questions.Question5 === '0' && this.state.questions.Question6 === '0' && this.state.questions.Question7 === '0' &&
      this.state.questions.Question8 === '0' && this.state.questions.Question4 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'White collar'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    }

    // Standard
    if(
      this.state.questions.Question3 === '0' && this.state.questions.Question4 === '0' && this.state.questions.Question5 === '0' &&
      this.state.questions.Question1 === '0' && this.state.questions.Question2 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'Standard'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    } else if(
      this.state.questions.Question1 === '0' && this.state.questions.Question3 === '0' && this.state.questions.Question5 === '0' &&
      this.state.questions.Question6 === '0' && this.state.questions.Question7 === '0' && this.state.questions.Question8 === '0' &&
      this.state.questions.Question2 === '1' && this.state.questions.Question4 === '1'
    ) {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'Standard'
        }
      }),() => this.props.callbackParent(this.state.userInputs.occupationalRating));
    }
  }

  render() {
    return (
      <div>
      <div className="questions">
      <ol>
        <li><p>Are you:</p>
        <ul>
        <li>a registered or enrolled nurse or assistant in nursing who is qualified and currently practicing, or</li>
        <li>working in the retail section, or food and beverage service?</li>
        </ul>
        <RadioToggle id={'question'} name={'question1'} onChange={this.questions.Question1} />
        </li>
        <li><p>Are you:</p>
        <ul>
        <li>a qualified tradesperson currently working within your area of expertise (e.g. hairdresser, chef, plumber, electrician, plasterer, carpenter or concreter), or</li>
        <li>a skilled worker with light manual duties (e.g. jeweller, building inspector, laboratory technician, foreman, office equipment technician)?</li>
        </ul>
        <RadioToggle id={'question'} name={'question2'} onChange={this.questions.Question2}/>
        </li>
        <li><p>Are you:</p>
        <ul>
        <li>a police officer, firefighter, paramedic, or other emergency or protective services worker, including security guard or corrections officer, or</li>
        <li>a professional sportsperson, or</li>
        <li>working in a manual occupation which does not require trade qualifications and may be subject to accident or environment hazards (e.g. earthmover, driver, cleaner, labourer, factory worker, agricultural worker)?</li>
        </ul>
        <RadioToggle id={'question'} name={'question3'} onChange={this.questions.Question3}/>
        </li>
        <li><p>Are the usual work activities of your job considered office based or school teaching (meaning you spend at least 80% of your work time doing clerical, call centre, administrative or other office or classroom based activities), or</p>
        <p>Are you a medical practitioner, lawyer or engineer who spends at least 80% of your work hours in an office or clinical environment?</p>
        <RadioToggle id={'question'} name={'question4'} onChange={this.questions.Question4}/></li>
        <li><p>Do you currently perform, or intend to work in a job within the next 3 months that includes any of the following risky activities:</p>
          <ul>
            <li>handling firearms (other than as a police officer, correctional officer, or licensed security guard), dangerous chemicals or explosives?</li>
            <li>offshore work - oil and gas platforms or ships at sea, or</li>
            <li>being underground (in construction and mining environments) or underwater for more than 20% of total at work time, or</li>
            <li>working at heights over 20 metres in any environment requiring hard hat and harness for safety by law, or</li>
            <li>crop dusting, aerial mustering or any low level flying activity (defined as below 150m or 500ft), or</li>
            <li>flying more than 200 hours per annum as a passenger other than on a commercial airline, or as a pilot (fixed wing or helicopter)?</li>
          </ul>
          <RadioToggle id={'question'} name={'question5'} onChange={this.questions.Question5}/>
        </li>
        </ol>
        {
          this.state.questions.Question1 === '0' &&
          this.state.questions.Question2 === '0' &&
          this.state.questions.Question3 === '0' &&
          this.state.questions.Question4 === '1' &&
          this.state.questions.Question5 === '0' ? (
            <ol>
            <li><p>Are you earning more than $120,000 a year (before tax and employer paid superannuation) from your job?</p>
            <RadioToggle id={'question'} name={'question6'} onChange={this.questions.Question6}/></li>
            <li><p>Do you have a university qualification which you are using/is required in your current role?</p>
            <RadioToggle id={'question'} name={'question7'} onChange={this.questions.Question7}/></li>
            <li><p>Do you have a senior/executive level management role in your company? (your direct reports would be mid-level managers or skilled specialists in a sedentary setting), or</p>
            <p>Is your role considered professional (e.g. doctors, solicitors, accountants - requiring membership of a professional or government body to practise in your occupation)?</p>
            <RadioToggle id={'question'} name={'question8'} onChange={this.questions.Question8}/></li>
            </ol>
          ): null
        }

      </div>

      {
        this.state.questionsAnswered === true
        ? <a className="showRating-button" onClick={this.handleSubmit} >Show my rating</a>
        : null
      }
      </div>
    );
  }
}

GetHelp.defaultProps = {
  //callbackParent: '',
  yesNoItems: [
		{value: 1, labelText: "Yes"},
		{value: 0, labelText: "No"}
	]
};

GetHelp.propTypes = {
  callbackParent: React.PropTypes.func.isRequired,
  callbackQuestions: React.PropTypes.func.isRequired
};

export default GetHelp;



// WEBPACK FOOTER //
// ./src/components/forms/GetHelp.js